import {ExecuteScriptMessage} from "../../messages";
import {RootRef} from "../../common";
import {makeSerializable} from "../utils/serialization.ts";

export const ExecuteScriptHandlerExecutor = (event: ExecuteScriptMessage, replier: (data: any) => void, rootRef: RootRef) => {
    const __scriptInputs = event.scriptInputs ? event.scriptInputs : {}
    __scriptInputs.makeSerializable = makeSerializable;

    __scriptInputs.send = replier;
    __scriptInputs.rootRef = rootRef;
    __scriptInputs.__scriptInputs = __scriptInputs;

    const dynamicFunction = new Function(`return (${event.script})(...arguments)`);
    const ret = dynamicFunction(__scriptInputs);

    // const dynamicFunction = Function('send', 'rootRef','__scriptInputs', ...Object.keys(__scriptInputs), event.content ? event.content : '')
    //const ret = dynamicFunction(replier, rootRef, __scriptInputs, ...Object.values(__scriptInputs));
    replier(ret);
}
